import { selectFieldListDataFromMapPolygons } from 'app/containers/Field/slice/selectors';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { useMapSlice } from 'app/containers/Map/slice';
import {
  selectActivePolygonId,
  selectMapLoading,
} from 'app/containers/Map/slice/selectors';
import { RouteConstants } from 'app/routes';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';

export const useFieldList = ({ searchQuery }: { searchQuery: string }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const envId = useSelector(selectSelectedEnvId);

  const fieldListData = useSelector(selectFieldListDataFromMapPolygons);
  const loading = useSelector(selectMapLoading);
  const activeFieldId = useSelector(selectActivePolygonId);

  const { actions: mapActions } = useMapSlice();

  const openFieldDetails = (fieldId: number) => (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    if (envId) {
      history.push(
        generatePath(RouteConstants.field.details, {
          envId,
          fieldId,
        }),
      );
    }
  };

  const fieldListDataWithSearchApplied = useMemo(
    () =>
      fieldListData.map(field => {
        const query = searchQuery.toLowerCase().trim();

        if (!query.length) {
          return { ...field, isVisible: true };
        }

        const keywordsArr = query.split(' ');

        const isVisible = Boolean(
          keywordsArr.find(
            k =>
              field.name.toLowerCase().includes(k) ||
              field.area.toLowerCase().includes(k),
          ),
        );

        return { ...field, isVisible };
      }),
    [fieldListData, searchQuery],
  );

  const onFieldListItemClick = (fieldId: number) => () => {
    dispatch(mapActions.zoomOnPolygon(fieldId));
    dispatch(mapActions.toggleActivePolygonId(fieldId));
  };

  return {
    fieldListDataWithSearchApplied,
    t,
    loading,
    activeFieldId,
    openFieldDetails,
    onFieldListItemClick,
  };
};
